import'./inicio.css'
function Inicio(){
  return(
    <div className="inicio">
    <div className="intro">
     <h1>Bem-vindo ao Global Taxi!</h1>
    </div>
    <div className="banner">
     <img src="/intro.png" alt="Nosso Taxi" />
    </div>
     </div>
  )
}
export default Inicio;